import { Box } from "@mui/material";
import { CSSProperties } from "react";
import { Link } from "react-router-dom";
import TalentStatusIcon, { StatusTextStyle } from "../../../../../common/components/functional/talentStatus/TalentStatusIcon";
import { TalentStatus } from "../../../../talents/types/common";
import theme from "../../../../../theme";

// TODO: This component is used across multiple features (orders, feedbacks).
// Consider moving it to common/components/functional/links/ when refactoring shared link components.

type Props = {
  id: string;
  name: string;
  status?: TalentStatus;
  openInNewTab?: boolean;
  style?: CSSProperties;
};

export const TalentLink = ({
  id,
  name,
  status,
  openInNewTab = false,
  style = {},
}: Props) => {
  const openInNewTabProps = { target: "_blank", rel: "noopener noreferrer" };

  return (
    <Link
      to={`/home/talents/${id}/profile`}
      style={{
        textDecoration: "none",
        color: theme.palette.primary.main,
        fontSize: "16px",
        ...style,
      }}
      {...(openInNewTab && { ...openInNewTabProps })}
    >
      <Box display="flex" alignItems="center" gap={0.5} component="span">
        {name}
        {status && (
          <TalentStatusIcon status={status} statusTextStyle={StatusTextStyle.TOOLTIP} />
        )}
      </Box>
    </Link>
  );
};
